import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithStreams,
} from 'widgets/WidgetRegistry';
import PortfolioReturns from './PortfolioReturns';
import { PortfolioReturnsConfigurationState } from './store/configuration/PortfolioReturnsConfigurationState';
import State from 'store/State';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { OrderColumn } from 'communication/types/order/Order';
import { mapSymbolStreamField } from 'app/store/orders/mapping';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { portfolioReturnsDescription } from './description/portfolioReturnsDescription';
import { portfolioReturnsStreamConfig } from 'widgets/portfolioReturns/store/stream/stream-config';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { buildPortfolioReturnsConfigSlice } from 'widgets/portfolioReturns/store/configuration/configSlice';

const { initialConfigState } = buildPortfolioReturnsConfigSlice();

export const portfolioReturnsWidgetStrategy: WidgetStrategyWithConfig<PortfolioReturnsConfigurationState> &
    WidgetStrategyWithStreams = {
    title: 'Portfolio Returns',
    supportedHosts: ['layout'],
    reactComponentType: PortfolioReturns,
    initialConfigState,
    getRequiredOrderColumns,
    categories: [WidgetCategory.PORTFOLIO],
    description: portfolioReturnsDescription,
    streamConfigs: [portfolioReturnsStreamConfig],
    portfolioSelectionRequirements: PortfolioSelectionRequirements.Portfolio,
};

function getRequiredOrderColumns(
    state: State,
    widgetId: string,
    symbology: SymbologyValues
): OrderColumn[] {
    const symbolField = mapSymbolStreamField(symbology);
    return [symbolField, 'side', 'qty', 'avgPxC'];
}
